module.exports = __webpack_public_path__ + "img/border1.43121b91.png";